<template>
	<input id="external-search-input"
		   ref="externalSearchInput"
		   type="text"
		   name="external-search-input"
		   :placeholder="$t('search.placeholderInputName')"
		   @keyup="handleKeyup"
		   v-model="query"
		   autocomplete="off"
		   :class="{ 'side-opened': sideOpened }">
</template>

<script>
	import { mapState } from "vuex";
	import Vue from "vue";
	import {ExternalSearchService} from "@/services/ExternalSearchService";

	let controller = new AbortController

	export default {
		components: {
		},
		data() {
			return {
				paginated: false
			}
		},
		watch: {
			query() {
				this.search()
			}
		},
		computed: {
			...mapState([ "searchProcessing", "externalSearchOpened", "sideOpened" ]),
			query: {
				get() {
					return this.$store.state.externalSearchQuery
				},
				set(query) {
					this.$store.commit("setExternalSearchQuery", query)
				}
			}
		},
		methods: {
			cancelSearchRequest () {
				controller.abort()
				controller = new AbortController
			},
			async handleKeyup(e) {
				if (e.code === "ArrowDown" || e.code === "ArrowUp" || e.code === "Escape") {
					this.$refs.externalSearchInput.blur();
					return;
				}
			},
			async search() {
				if (this.query.length <= 2) {
					this.$store.commit("setExternalSongs", []);
					return;
				}

				this.$store.commit("setSearchProcessing", true);
				this.paginated = false
				this.cancelSearchRequest();

				ExternalSearchService.search({
					query: this.query,
					limit: 20,
					signal: controller.signal
				}).then(items => {
					this.$store.commit("setSearchProcessing", false);
					this.$store.commit("setExternalSongs", items);
				})
			},
			async paginateSearch() {
				this.paginated = true
				ExternalSearchService.search({
					query: this.query,
					limit: 60,
					offset: 20,
					signal: controller.signal
				}).then(items => {
					this.$store.commit("addExternalSongs", items);
				})
			},
			keydownEvent(e) {
				if (this.localSearchOpened) return;
				if (!this.externalSearchOpened) return;
				if (e.code === "Escape") {
					this.$store.commit("setRootSideOpened", false);
					this.$store.commit("setExternalSearchOpened", false);
					return;
				}
				if (e.srcElement.tagName === "TEXTAREA" || e.srcElement.tagName === "INPUT") return;
				if (e.code === "KeyA" || e.code === "Backspace") {
					Vue.nextTick(() => {
						this.$refs.externalSearchInput.focus();
						this.$refs.externalSearchInput.select();
					});
				}
			},
			handleScroll() {
				if (!this.paginated) this.paginateSearch();
			}
		},
		mounted() {
			document.addEventListener("keyup", this.keydownEvent);

			Vue.nextTick(() => {
				this.$refs.externalSearchInput.focus()
			});
		},
		destroyed() {
			document.removeEventListener("keyup", this.keydownEvent);
		}
	}
</script>

<style lang="scss" scoped>
	input#external-search-input {
		position: fixed;
		left: -260px;
		top: 50px;
		top: calc(constant(safe-area-inset-top) + 50px);
		top: calc(env(safe-area-inset-top) + 50px);
		width: 230px;
		height: 50px;
		padding: 0 15px;
		line-height: 50px;
		background-color: rgba(67, 90, 100, 0.75);
		font-weight: 300;
		color: rgba(255, 255, 255, 0.8);
		border: 0;
		margin-bottom: 1px;

		-webkit-transition: height 0.2s, left 0.2s;
		-moz-transition: height 0.2s, left 0.2s;
		-o-transition: height 0.2s, left 0.2s;
		transition: height 0.2s, left 0.2s;

		&.side-opened {
			left: 0;
		}

		&::placeholder {
			color: rgba(255, 255, 255, 0.49);
		}

		&:focus {
			outline: none;
		}
	}
</style>
